var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6749 20.5646L11.6025 20.9488C11.682 20.9744 11.788 21 11.8675 21C11.947 21 12.053 20.9744 12.1325 20.9488L13.1926 20.5133C17.0354 18.9764 19.5 15.3904 19.5 11.3689V6.39959C19.5 6.16906 19.3675 5.93852 19.1555 5.83607L12.212 2.25L4.84452 5.83607C4.63251 5.93852 4.5 6.16906 4.5 6.39959V11.4713C4.5 15.416 6.91167 18.9764 10.6749 20.5646ZM9.16432 10.5236L10.993 12.5984L15.2332 9.26844L16.0813 10.2674L11.364 14.0072L10.8604 14.417L10.4364 13.9303L8.18376 11.3689L9.16432 10.5236Z",
    fill: "#717F8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPci);
export default __webpack_public_path__ + "static/media/pci.0161316bb4d716b8959563376c777fa6.svg";
export { ForwardRef as ReactComponent };